module.exports = __webpack_public_path__ + "img/arrow-up.d517f5d8.svg";